import { createContext } from 'react'
import { globalEventBus } from '../events'
import { callbacks } from '../globals'
import { HostContextValue } from './types'

export const HostContext = createContext<HostContextValue>({
  callbacks,
  globalEventBus,
})

export const HostContextProvider = HostContext.Provider
